import React from 'react';
import { Link } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { formatCurrency } from '../../format/Currency';
import { MatchingInmate } from './MergeAll';

type MatchingInmatesTableProps = {
  inmates: MatchingInmate[];
  getMergeDateForInmate: (inmateId: number) => string | null;
};

const MatchingInmatesTable: React.FC<MatchingInmatesTableProps> = ({
  inmates,
  getMergeDateForInmate
}) => {
  return (
    <Card className="mb-3">
      <Card.Header>
        <strong>Matching Inmates</strong>
      </Card.Header>
      <Card.Body>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Name</th>
              <th>Account</th>
              <th>Facility</th>
              <th>Messaging Balance</th>
              <th>AV Balance</th>
              <th>Contacts</th>
            </tr>
          </thead>
          <tbody>
            {inmates.map((inmate) => {
              const mergeDate = getMergeDateForInmate(inmate.id);

              return (
                <tr key={inmate.id}>
                  <td>
                    {mergeDate && (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id={`merge-tooltip-${inmate.id}`}>
                            Merged {mergeDate}
                            {inmate.canBeReMerged && ' (can be re-merged)'}
                          </Tooltip>
                        }>
                        <i className={`fas fa-code-branch ${inmate.canBeReMerged ? 'text-warning' : 'text-success'}`} style={{ marginRight: '0.5rem' }} />
                      </OverlayTrigger>
                    )}
                    {inmate.canBeReMerged && !mergeDate && (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id={`remerge-tooltip-${inmate.id}`}>
                            Can be re-merged (they have been re-booked since last merge)
                          </Tooltip>
                        }>
                        <i className="fas fa-redo text-warning" style={{ marginRight: '0.5rem' }} />
                      </OverlayTrigger>
                    )}
                    <Link to={`/inmates/view/${inmate.id}`}>
                      {inmate.firstName} {inmate.lastName}
                    </Link>
                  </td>
                  <td>#{inmate.account}</td>
                  <td>
                    <Link to={`/facilities/view/${inmate.facility.id}`}>
                      {inmate.facility.name}{inmate.facility.state ? ` (${inmate.facility.state})` : ''}
                    </Link>
                  </td>
                  <td>{formatCurrency(inmate.messagingBalance * -1)}</td>
                  <td>{formatCurrency(inmate.audioVideoBalance * -1)}</td>
                  <td>{inmate.contacts.length}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default MatchingInmatesTable;
